import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterLink, RouterLinkActive } from "@angular/router";
import {
  DateFormatPipe,
  HardBtnComponent,
  HardFormModule,
  HardModalComponent,
  HardLoadingComponent,
  HardNoDataComponent,
  HardPaginatorComponent,
  HardTranslatePipe,
  HardCalendarModule,
  HardPermissionDirective,
  HardMenuComponent,
} from "@hardcode-kz/ui";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { NgbPopover, NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { NotificationsModalComponent } from "./notifications-modal/notifications-modal.component";
import { ContactSupportModalComponent } from "./contact-support-modal/contact-support-modal.component";
import { ToolbarMenuComponent } from "./toolbar-menu/toolbar-menu.component";
import { StopPropagationDirective } from "@dmms/shared/utils/directives";
import { ToolbarMenuItemComponent } from "./toolbar-menu-item/toolbar-menu-item.component";
import { ToolbarComponent } from "./toolbar/toolbar.component";

@NgModule({
  declarations: [
    ToolbarComponent,
    NotificationsModalComponent,
    ContactSupportModalComponent,
    ToolbarMenuComponent,
    ToolbarMenuItemComponent,
  ],
  imports: [
    RouterLink,
    RouterLinkActive,
    CommonModule,
    HardBtnComponent,
    MatIconModule,
    NgbPopover,
    DateFormatPipe,
    HardTranslatePipe,
    TranslateModule,
    HardBtnComponent,
    HardModalComponent,
    HardPaginatorComponent,
    HardLoadingComponent,
    HardNoDataComponent,
    HardFormModule,
    HardCalendarModule,
    HardPermissionDirective,
    NgbTooltip,
    HardMenuComponent,
    StopPropagationDirective,
  ],
  providers: [DateFormatPipe, TranslateService],
  exports: [ToolbarComponent],
})
export class ToolbarModule {}
